import { Component, OnInit, OnChanges, AfterViewInit, AfterViewChecked, AfterContentInit } from '@angular/core';
import { Router } from '@angular/router';
import { appConstants } from 'src/app/common-service/const.model';
import { FormControl } from '@angular/forms';
import { HelperService } from 'src/app/common-service/helper.service';
import { HttpServiceService } from 'src/app/common-service/http-service.service';
import { LegalServicesService } from 'src/app/legal/services/legalServices.service';
import { ServerURLService } from 'src/app/common-service/serverURL.service';
import { encryptionService } from 'src/app/common-service/cedService';
import { SignupService } from 'src/app/common-service/signup.service';
import { ComplaintService } from 'src/app/griviance/services/complaint/complaint.service';
import { EligibilityCertificateService } from 'src/app/eligibility-certificate/eligibility-certificate-service';

@Component({
  selector: 'app-internal-dash',
  templateUrl: './internal-dash.component.html',
  styleUrls: ['./internal-dash.component.css']
})
export class InternalDashComponent implements OnInit {
  roleName: any;
  linkValue: string;
  userData: any;
  moduleName: any = [];
  cardData: any = [];
  advocateDetails: any = [];
  DMSLink: any;
  ERPLink: any;
  NOCLink:any;
  HelpDeskLink:any;
  AccountsLink:any;
  ProfileLink:any;
  sectionId: number;
  MISLink: any;
  MDMLink: any;
  HRMSLink: any;
  NOCemail: any;
  NOCpass: any;
  randomSecretKey: any;
  decryptrandomSecretKey: any;
  AdminNOCpass: any;
  AdminNOCemail: any;
  Profileemail: any;
  Profilepass: any;
  complaintCount: number = 0;
  eligibilityCount: number = 0;
  hostName: any;
  entityId: any;
  showSAR: boolean = false;

  name = new FormControl();
  constructor(public helper: HelperService, public legalService: LegalServicesService, 
    public router: Router, public appconst: appConstants, public http: HttpServiceService, public signin: SignupService,
    public ced: encryptionService, public serverURL: ServerURLService, public complSer: ComplaintService, public ecService: EligibilityCertificateService) { }

  ngOnInit(): void {
  
    // For Change Role
    this.helper.getNotification()
      .subscribe((notifyData) => {
        if (notifyData !== null) {
          this.userData = JSON.parse(sessionStorage.getItem('userInfo-usec'));
          this.roleName = sessionStorage.getItem('selectedRole-usec');
          this.moduleName = [];
          this.userData.rolesList.forEach(element => {
            if (element.roleName === this.roleName) {
              element.authorities.forEach(privi => {
                this.moduleName.push(privi.applicationModule.moduleName);
              });
            }
          });
          // if (this.roleName === 'PDMSSectionOfficer'|| this.roleName === 'PDMSAssistantSectionOfficer'|| this.roleName === 'PDMSExecutive'
          //   || this.roleName === 'PDMSSecInCharge'|| this.roleName === 'PDMSAsstSecty'|| this.roleName === 'Joint Secretary') {
          //   this.moduleName.push('Inspection');
          // }
        }
      });

      // this.showSARCard();
    // Default ROle
    this.userData = JSON.parse(sessionStorage.getItem('userInfo-usec'));
    this.roleName = sessionStorage.getItem('selectedRole-usec');
    if(JSON.parse(sessionStorage.getItem('userInfo-usec')).section!=null){
      this.sectionId = JSON.parse(sessionStorage.getItem('userInfo-usec')).section.sectionId
    }

    if(this.roleName==='Advocate'){
      this.legalService.advocateDetailsByUserId(this.userData.userId).subscribe((result: any) => {
        this.advocateDetails=result;
         }, error => {
             this.helper.errorMessage(error);
         });    
    }  
    // this.userData.rolesList.forEach(element => {
    //   if (element.roleName === this.roleName) {
    //     element.authorities.forEach(privi => {
    //       this.moduleName.push(privi.applicationModule.moduleName);
    //     });
    //   }
    // });
  
    
   
    this.DMSLink = `${this.serverURL.apiServerAddress}user-management/api/v1/user/dmsUrl`;
    this.ERPLink = `${this.serverURL.apiServerAddress}user-management/api/v1/user/ERPUrl`;
    
    if(this.roleName === 'College Principal' || this.roleName === 'Student' || this.roleName === 'General Public') {
      this.getComplaintListCount();
    }
    
    // if(this.roleName === 'AFSecInCharge' || this.roleName === 'College Principal'
    // ){
    //   this.moduleName.push('FeeCollection');
    // }

    if(this.roleName === 'Student') {
      this.getEligibilityListCount();
    }

    // this.sendMobileOTPTemplate();
  }

  //Testing for particular college only 
  showSARCard() {
    this.hostName = window.location.hostname;
    this.entityId = sessionStorage.getItem('entityId-usec');

    if(this.roleName === 'College Principal' || this.roleName === 'College Representative') {
      if(this.hostName === '103.210.72.123' || this.hostName === 'localhost' || 
      ((this.hostName === 'portal.dciindia.gov.in' || this.hostName === '36.255.253.200') && 
      (this.entityId === '288' || this.entityId === '164' || this.entityId === '142' || this.entityId === '380'))) {
        this.showSAR = true;
      } else {
        this.showSAR = false;
      }
    } else {
      this.showSAR = true;
    }

  }

  sendUsernew(value: any) {
    switch (this.roleName) {
    case 'PDMSSectionOfficer':
       if (value === 'DakDairy') {
            this.router.navigate(['/main/internal/outbound/se/dashboard']);  
          } else if (value === 'ecAgenda') {
            this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
          } else if (value === 'Grievance') {
            this.router.navigate(['/main/internal/grievance/section/dashboard']);
          } else if (value === 'PTR') {
            this.router.navigate(['/main/internal/ptr/sectionExcutive/secExePtrDashBoard']);
          } else if(value === 'Eligibility') {
            this.router.navigate(['/main/internal/eligibility/secDashboard']);
          }
  }
  }
  sendUser(value: any) {
    
    switch (this.roleName) {
      // AcademicUncharged ------Academic
      case 'Executive Committee':
        if(value == 'ecAgenda'){
          this.router.navigate(['/main/internal/excu/ec/dashboard']);
        } 
        break; 
      // AcademicAsstSecty 
      case 'AcademicAsstSecty':
        if (value === 'DakDairy') {
          this.router.navigate(['/main/internal/outbound/se/dashboard']);
        }else if(value == 'ecAgenda'){
          this.router.navigate(['/main/internal/excu/ec/dashboard']);
        } else if (value === 'Inspection') {
          this.router.navigate(['/main/internal/inspection/insCell/inspList']);
        } else if(value === 'SAR') {
          this.router.navigate(['/main/internal/college/viewSar/collegeList']);    // College Profile Management
        } 
        case 'AdmsnAsstSecty':
          if (value === 'DakDairy') {
            this.router.navigate(['/main/internal/outbound/se/dashboard']);
          } else if(value == 'ecAgenda'){
            this.router.navigate(['/main/internal/excu/ec/dashboard']);
          } else if(value === 'StudentAdmission') {
            this.router.navigate(['/main/internal/college/admissionMonitorCellExecutive/collegelist']);// Student Admission Module
          }
           break;

       case 'CA':
           if(value === 'StudentAdmission') {
            this.router.navigate(['/main/internal/college/admissionMonitorCellExecutive/studentAdmissionDetails']);// Student Admission Module
          }
          case 'University':
           if(value === 'StudentAdmission') {
            this.router.navigate(['/main/internal/college/admissionMonitorCellExecutive/studentAdmissionDetails']);// Student Admission Module
          }
        case 'RTIAssistantSectionOfficer':
          if (value === 'DakDairy') {
            this.router.navigate(['/main/internal/outbound/se/dashboard']);  // Diary Dak Module
          }
        case 'LegalSectionOfficer':
          if (value === 'DakDairy') {
            this.router.navigate(['/main/internal/outbound/se/dashboard']);  // Diary Dak Module
          } else if (value === 'Legal') {
            this.router.navigate(['/main/internal/legal/caseFileManagement']);
          } 

          case 'LegalRetainer':
          if (value === 'DakDairy') {
            this.router.navigate(['/main/internal/outbound/se/dashboard']);  
          } else if (value === 'ecAgenda') {
            this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
          } else if (value === 'Legal') {
            this.router.navigate(['/main/internal/legal/caseFileManagement']);
          } 
  
          break;
          case 'RTILegalRetainer':
          if (value === 'DakDairy') {
            this.router.navigate(['/main/internal/outbound/se/dashboard']);  
          } else if (value === 'ecAgenda') {
            this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
          } else if (value === 'Legal') {
            this.router.navigate(['/main/internal/legal/caseFileManagement']);
          } 
  
          break;
      // AcademicSectionOfficer 
      case 'AcademicSectionOfficer':
        if (value === 'DakDairy') {
          this.router.navigate(['/main/internal/outbound/se/dashboard']);  
        } else if (value === 'ecAgenda') {
          this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
        } else if (value === 'Inspection') {
          this.router.navigate(['/main/internal/inspection/insCell/inspList']);
        } else if(value === 'SAR') {
          this.router.navigate(['/main/internal/college/viewSar/collegeList']);    // College Profile Management
        } 
        break;
        case 'RTISectionOfficer':
          if (value === 'DakDairy') {
            this.router.navigate(['/main/internal/outbound/se/dashboard']);  
          } else if (value === 'ecAgenda') {
            this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
          }
        break;
        case 'AdmsnSectionOfficer':
          if (value === 'DakDairy') {
            this.router.navigate(['/main/internal/outbound/se/dashboard']);  
          } else if (value === 'ecAgenda') {
            this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
          } else if(value === 'StudentAdmission') {
            this.router.navigate(['/main/internal/college/admissionMonitorCellExecutive/collegelist']);// Student Admission Module
          }
          break;
        case 'AdmsnAssistantSectionOfficer':
        if (value === 'DakDairy') {
          this.router.navigate(['/main/internal/outbound/se/dashboard']);  
        } else if (value === 'ecAgenda') {
          this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
        } else if(value === 'StudentAdmission') {
          this.router.navigate(['/main/internal/college/admissionMonitorCellExecutive/collegelist']);// Student Admission Module
        }
        break;
        case 'UGPG Consultant':
        if(value === 'StudentAdmission') {
          this.router.navigate(['/main/internal/college/admissionMonitorCellExecutive/collegelist']);// Student Admission Module
        }
        break;
        case 'PDMSSectionOfficer':
          if (value === 'DakDairy') {
            this.router.navigate(['/main/internal/outbound/se/dashboard']);  
          } else if (value === 'ecAgenda') {
            this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
          } else if (value === 'Grievance') {
            this.router.navigate(['/main/internal/grievance/section/dashboard']);
          } else if (value === 'PTR') {
            this.router.navigate(['/main/internal/ptr/sectionExcutive/secExePtrDashBoard']);
          }else if (value === 'Inspection') {
            this.router.navigate(['/main/internal/inspection/insCell/inspList']);
          } else if(value === 'Eligibility') {
            this.router.navigate(['/main/internal/eligibility/secDashboard']);
          }
        break;
      case 'AcademicAssistantSectionOfficer':
        if (value === 'DakDairy') {
          this.router.navigate(['/main/internal/outbound/se/dashboard']);  
        } else if (value === 'ecAgenda') {
          this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
        } else if (value === 'Inspection') {
          this.router.navigate(['/main/internal/inspection/insCell/inspList']);
        } else if(value === 'SAR') {
          this.router.navigate(['/main/internal/college/viewSar/collegeList']);    // College Profile Management
        } 
        break;
        case 'Accountant':
          if (value === 'DakDairy') {
            this.router.navigate(['/main/internal/outbound/se/dashboard']);  
          } else if (value === 'ecAgenda') {
            this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
          }
        break;
        case 'PDMSAssistantSectionOfficer':
          if (value === 'DakDairy') {
            this.router.navigate(['/main/internal/outbound/se/dashboard']);  // Diary Dak Module
          } else if (value === 'Grievance') {
            this.router.navigate(['/main/internal/grievance/section/dashboard']);
          }  else if (value === 'PTR') {
            this.router.navigate(['/main/internal/ptr/sectionExcutive/secExePtrDashBoard']);
          } else if (value === 'ecAgenda') {
            this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
          }else if (value === 'Inspection') {
            this.router.navigate(['/main/internal/inspection/insCell/inspList']);
          } else if(value === 'Eligibility') {
            this.router.navigate(['/main/internal/eligibility/secDashboard']);
          }
        break;
      //AcademicExecutive 
      case 'AcademicExecutive':
        if (value === 'DakDairy') {
          this.router.navigate(['/main/internal/outbound/se/dashboard']);  
        } else if (value === 'ecAgenda') {
          this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
        } else if (value === 'Inspection') {
          this.router.navigate(['/main/internal/inspection/insCell/inspList']);
        } else if(value === 'SAR') {
          this.router.navigate(['/main/internal/college/viewSar/collegeList']);    // College Profile Management
        }        
        break;
        case 'ServerSecExecutive':
        if (value === 'DakDairy') {
          this.router.navigate(['/main/internal/outbound/se/dashboard']);  
        } else if (value === 'ecAgenda') {
          this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
        } else if (value === 'User-Management') {
          this.router.navigate(['/main/internal/usrmgt/internalApp']);
        } else if (value === 'Audit Log') {
          this.router.navigate(['/main/internal/auditLog/dashboard']);
        } else if (value === 'MDM') {
          this.router.navigate(['/main/internal/mdm/common/countryMaster']);
        } else if(value === 'StudentAdmission') {
          this.router.navigate(['/main/internal/college/admissionMonitorCellExecutive/collegelist']);// Student Admission Module
        } else if(value === 'SAR') {
          this.router.navigate(['/main/internal/college/viewSar/collegeList']);    // College Profile Management
        } else if (value === 'Legal') {
          this.router.navigate(['/main/internal/legal/caseFileManagement']);
        } else if (value === 'Inspection') {
          this.router.navigate(['/main/internal/inspection/inspMaster/holiday']);
        } else if (value === 'SLA') {
          this.router.navigate(['/main/internal/sla/slaReportsDashboard']);
        } else if (value === 'AntiRagging') {
            this.router.navigate(['/main/internal/antiRagging/sectionantiRaggingDashboard']);
          } 
        break;
        case 'PDMSExecutive':
          if (value === 'DakDairy') {
            this.router.navigate(['/main/internal/outbound/se/dashboard']);  
          } else if (value === 'ecAgenda') {
            this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
          } else if (value === 'Grievance') {
            this.router.navigate(['/main/internal/grievance/section/dashboard']);
          } else if (value === 'PTR') {
            this.router.navigate(['/main/internal/ptr/sectionExcutive/secExePtrDashBoard']);
          }else if (value === 'Inspection') {
            this.router.navigate(['/main/internal/inspection/insCell/inspList']);
          } else if(value === 'Eligibility') {
            this.router.navigate(['/main/internal/eligibility/secDashboard']);
          }
        break;
      case 'ACADSecInCharge':
        this.router.navigate(['/main/internal/outbound/secInch/IncDashboard']);
        break;

        case 'InspAsstSecty':
          if (value === 'Grievance') {
            this.router.navigate(['/main/internal/grievance/section/dashboard']);
          } else if (value === 'ecAgenda') {
            this.router.navigate(['/main/internal/excu/sectionHead/agendaDashBoard']);
          } else if (value === 'DakDairy') {
            this.router.navigate(['/main/internal/outbound/secInch/IncDashboard']);  // Diary Dak Module
          }else if (value === 'Inspection') {
            this.router.navigate(['/main/internal/inspection/insCell/inspList']);
          }        
          break;

          case 'MSAsstSecty':
            if (value === 'Grievance') {
              this.router.navigate(['/main/internal/grievance/section/dashboard']);
            } else if (value === 'ecAgenda') {
              this.router.navigate(['/main/internal/excu/sectionHead/agendaDashBoard']);
            } else if (value === 'DakDairy') {
              this.router.navigate(['/main/internal/outbound/secInch/IncDashboard']);  // Diary Dak Module
            }else if (value === 'Inspection') {
              this.router.navigate(['/main/internal/inspection/insCell/inspList']);
          }        
            break;    
          
      //RTI Section
      case 'RTIExecutive':
        if (value === 'DakDairy') {
          this.router.navigate(['/main/internal/outbound/se/dashboard']);  
        } else if (value === 'ecAgenda') {
          this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
        }
        break;

      // Grievance Module
      case 'General Public':
        if (value === 'Grievance') {
          if(this.complaintCount === 0) {
            this.router.navigate(['/main/internal/grievance/complaint/new']);
          } else {
            this.router.navigate(['/main/internal/grievance/complaint/dashboard']);
          } 
        }
        break;

        case 'PDMSSecInCharge':
        if (value === 'Grievance') {
          this.router.navigate(['/main/internal/grievance/section/dashboard']);
        } else if (value === 'ecAgenda') {
          this.router.navigate(['/main/internal/excu/sectionHead/agendaDashBoard']);
        } else if (value === 'DakDairy') {
          this.router.navigate(['/main/internal/outbound/secInch/IncDashboard']);  // Diary Dak Module
        } else if (value === 'PTR') {
          this.router.navigate(['/main/internal/ptr/sectionHead/secHeadPtrDashBoard']);
        } else if (value === 'Inspection') {
          this.router.navigate(['/main/internal/inspection/insCell/inspList']);
        }else if(value === 'Eligibility') {
          this.router.navigate(['/main/internal/eligibility/secDashboard']);
        }
         // Anti-Ragging By Riyaz         
        break;


        case 'AcademicIncharge':
          if (value === 'Grievance') {
            this.router.navigate(['/main/internal/grievance/section/dashboard']);
          } else if (value === 'ecAgenda') {
            this.router.navigate(['/main/internal/excu/sectionHead/agendaDashBoard']);
          } else if (value === 'DakDairy') {
            this.router.navigate(['/main/internal/outbound/secInch/IncDashboard']);  // Diary Dak Module
          } else if (value === 'Inspection') {
            this.router.navigate(['/main/internal/inspection/insCell/inspList']);
          } else if(value === 'SAR') {
            this.router.navigate(['/main/internal/college/viewSar/collegeList']);    // College Profile Management
          } 
  
          break;

          case 'ARPMSecInCharge':
          if (value === 'Grievance') {
            this.router.navigate(['/main/internal/grievance/section/dashboard']);
          } else if (value === 'ecAgenda') {
            this.router.navigate(['/main/internal/excu/sectionHead/agendaDashBoard']);
          } else if (value === 'DakDairy') {
            this.router.navigate(['/main/internal/outbound/secInch/IncDashboard']);  // Diary Dak Module
          } else if (value === 'AntiRagging') {
            this.router.navigate(['/main/internal/antiRagging/sectionantiRaggingDashboard']);
          } 
  
          break;

          case 'AEIncharge':
          if (value === 'Grievance') {
            this.router.navigate(['/main/internal/grievance/section/dashboard']);
          } else if (value === 'ecAgenda') {
            this.router.navigate(['/main/internal/excu/sectionHead/agendaDashBoard']);
          } else if (value === 'DakDairy') {
            this.router.navigate(['/main/internal/outbound/secInch/IncDashboard']);  // Diary Dak Module
          }
  
          break;


          case 'AFSecInCharge':
            if (value === 'Grievance') {
              this.router.navigate(['/main/internal/grievance/section/dashboard']);
            } else if (value === 'ecAgenda') {
              this.router.navigate(['/main/internal/excu/sectionHead/agendaDashBoard']);
            } else if (value === 'DakDairy') {
              this.router.navigate(['/main/internal/outbound/secInch/IncDashboard']);  // Diary Dak Module
            } else if(value == 'Fee Collection') {
              this.router.navigate(['/main/internal/college/feecollectiondetails/feecollection']);
            }
    
            break;

            case 'LegalSecInCharge':
            if (value === 'Grievance') {
              this.router.navigate(['/main/internal/grievance/section/dashboard']);
            } else if (value === 'ecAgenda') {
              this.router.navigate(['/main/internal/excu/sectionHead/agendaDashBoard']);
            } else if (value === 'DakDairy') {
              this.router.navigate(['/main/internal/outbound/secInch/IncDashboard']);  // Diary Dak Module
            } else if (value === 'Legal') {
              this.router.navigate(['/main/internal/legal/caseFileManagement']);
            } 
    
            break;

            case 'AdmsnIncharge':
            if (value === 'Grievance') {
              this.router.navigate(['/main/internal/grievance/section/dashboard']);
            } else if (value === 'ecAgenda') {
              this.router.navigate(['/main/internal/excu/sectionHead/agendaDashBoard']);
            } else if (value === 'DakDairy') {
              this.router.navigate(['/main/internal/outbound/secInch/IncDashboard']);  // Diary Dak Module
            } else if(value === 'StudentAdmission') {
              this.router.navigate(['/main/internal/college/admissionMonitorCellExecutive/collegelist']);// Student Admission Module
            }
    
            break;
            case 'President UG-PG':
            if(value === 'StudentAdmission') {
              this.router.navigate(['/main/internal/college/admissionMonitorCellExecutive/collegelist']);// Student Admission Module
            }
    
            break;
            case 'ISecInCharge':
            if (value === 'Grievance') {
              this.router.navigate(['/main/internal/grievance/section/dashboard']);
            } else if (value === 'ecAgenda') {
              this.router.navigate(['/main/internal/excu/sectionHead/agendaDashBoard']);
            } else if (value === 'DakDairy') {
              this.router.navigate(['/main/internal/outbound/secInch/IncDashboard']);  // Diary Dak Module
            }
    
            break;

            case 'RTISecInCharge':
            if (value === 'Grievance') {
              this.router.navigate(['/main/internal/grievance/section/dashboard']);
            } else if (value === 'ecAgenda') {
              this.router.navigate(['/main/internal/excu/sectionHead/agendaDashBoard']);
            } else if (value === 'DakDairy') {
              this.router.navigate(['/main/internal/outbound/secInch/IncDashboard']);  // Diary Dak Module
            }
    
            break;
            case 'ServerSecInCharge':
            if (value === 'Grievance') {
              this.router.navigate(['/main/internal/grievance/section/dashboard']);
            } else if (value === 'ecAgenda') {
              this.router.navigate(['/main/internal/excu/sectionHead/agendaDashBoard']);
            } else if (value === 'DakDairy') {
              this.router.navigate(['/main/internal/outbound/secInch/IncDashboard']);  // Diary Dak Module
            }
    
            break;

        case 'ARPMAsstSecty':
          if (value === 'DakDairy') {
            this.router.navigate(['/main/internal/outbound/se/dashboard']);  // Diary Dak Module
          } else if (value === 'Grievance') {
            this.router.navigate(['/main/internal/grievance/section/dashboard']);
          } else if (value === 'ecAgenda') {
            this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
          } else if (value === 'AntiRagging') {
            this.router.navigate(['/main/internal/antiRagging/sectionantiRaggingDashboard']);
          } 
  
          break;
          case 'PDMSAsstSecty':
            if (value === 'DakDairy') {
              this.router.navigate(['/main/internal/outbound/se/dashboard']);  // Diary Dak Module
            } else if (value === 'ecAgenda') {
              this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
            } else if (value === 'Grievance') {
              this.router.navigate(['/main/internal/grievance/section/dashboard']);
            } else if (value === 'PTR') {
              this.router.navigate(['/main/internal/ptr/sectionExcutive/secExePtrDashBoard']);
            } else if (value === 'Inspection') {
              this.router.navigate(['/main/internal/inspection/insCell/inspList']);
            }else if(value === 'Eligibility') {
              this.router.navigate(['/main/internal/eligibility/secDashboard']);
            }
    
            break;
          case 'ARPMAssistantSectionOfficer':
          if (value === 'DakDairy') {
            this.router.navigate(['/main/internal/outbound/se/dashboard']);  // Diary Dak Module
          } else if (value === 'Grievance') {
            this.router.navigate(['/main/internal/grievance/section/dashboard']);
          } else if (value === 'ecAgenda') {
            this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
          } else if (value === 'AntiRagging') {
            this.router.navigate(['/main/internal/antiRagging/sectionantiRaggingDashboard']);
          } 
  
          break;
      case 'ARPMSecExecutive':
        if (value === 'Grievance') {
          this.router.navigate(['/main/internal/grievance/section/dashboard']);
        } else if (value === 'DakDairy') {
          this.router.navigate(['/main/internal/outbound/se/dashboard']);
        } else if (value === 'ecAgenda') {
          this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
        } else if (value === 'AntiRagging') {
          this.router.navigate(['/main/internal/antiRagging/sectionantiRaggingDashboard']);
        } else if (value === 'DMS') {
          this.http.get(`${this.serverURL.apiServerAddress}user-management/api/v1/user/dmsUrl`).subscribe((res: any) => {
            window.open(res.dmsUrl, "_blank");
          }, error => {
            console.log(error);
          })
        }else if(value === 'ERP'){
          this.http.get(`${this.serverURL.apiServerAddress}user-management/api/v1/user/ERPUrl`).subscribe((res: any) => {
            window.open(res.erpUrl, "_blank");
          }, error => {
            console.log(error);
          })
        }
        break;
        case 'AdmsnSecExecutive':
        if (value === 'Grievance') {
          this.router.navigate(['/main/internal/grievance/section/dashboard']);
        } else if (value === 'ecAgenda') {
          this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
        } else if (value === 'DakDairy') {
          this.router.navigate(['/main/internal/outbound/se/dashboard']);
        } else if (value === 'DMS') {
          this.http.get(`${this.serverURL.apiServerAddress}user-management/api/v1/user/dmsUrl`).subscribe((res: any) => {
            window.open(res.dmsUrl, "_blank");
          }, error => {
            console.log(error);
          })
        }else if(value === 'ERP'){
          this.http.get(`${this.serverURL.apiServerAddress}user-management/api/v1/user/ERPUrl`).subscribe((res: any) => {
            window.open(res.erpUrl, "_blank");
          }, error => {
            console.log(error);
          })
        } else if(value === 'StudentAdmission') {
          this.router.navigate(['/main/internal/college/admissionMonitorCellExecutive/collegelist']);// Student Admission Module
        }
        break;

        case 'UGPG-DEB':
         if(value === 'StudentAdmission') {
          this.router.navigate(['/main/internal/college/admissionMonitorCellExecutive/collegelist']);// Student Admission Module
        }
        break;
      // case 'ARPMSubCommittee':
      //   this.router.navigate(['/main/internal/grievance/subCom/dashboard']);
      //   break;
      // case 'ARPMExeCommittee':
      //   this.router.navigate(['/main/internal/grievance/excutive/dashboard']);
      //   this.helper.sendNotification('griviance');
      //   break;
      //   case 'Executive Commitee':
      //   this.router.navigate(['/main/internal/grievance/excutive/dashboard']);
      //   this.helper.sendNotification('griviance');
      //   break;
      // case 'CollegeRep':
      //   this.router.navigate(['/main/internal/grievance/college/dashboard']);
      //   break;
      // Diary Dak Module
      case 'DAK_Section_Executive':
        this.router.navigate(['/main/internal/outbound/se/dashboard']);
        break;

      case 'RDSecInCharge':
        this.router.navigate(['/main/internal/inbound/diarydakincharge/receiptDashboard']);
        break;
        case 'R&DSecExecutive':
          this.router.navigate(['/main/internal/inbound/diarydakincharge/dispatchdashboard']);
          break;
      case 'System Admin':
        if (value === 'User-Management') {
          this.router.navigate(['/main/internal/usrmgt/internalApp']);
        } else if (value === 'Audit Log') {
          this.router.navigate(['/main/internal/auditLog/dashboard']);
        } else if (value === 'MDM') {
          this.router.navigate(['/main/internal/mdm/common/countryMaster']);
        } else if(value === 'StudentAdmission') {
          this.router.navigate(['/main/internal/college/admissionMonitorCellExecutive/collegelist']);// Student Admission Module
        } else if (value === 'SLA') {
          this.router.navigate(['/main/internal/sla/slaReportsDashboard']);
        } else if(value === 'SAR') {
          this.router.navigate(['/main/internal/college/viewSar/collegeList']);    // College Profile Management
        } else if (value === 'AntiRagging') {
          this.router.navigate(['/main/internal/antiRagging/sectionantiRaggingDashboard']);
        } else if (value === 'Legal') {
          this.router.navigate(['/main/internal/legal/caseFileManagement']);
        } else if (value === 'Inspection') {
          this.router.navigate(['/main/internal/inspection/insCell/newinspList']);
        }   
        break;
        
      case 'Joint Secretary':
          if (value === 'ecAgenda') {
            this.router.navigate(['/main/internal/excu/CZsQVJe0x6/ReviewMeetingComponent']);
          } else if (value === 'Inspection') {
            this.router.navigate(['/main/internal/inspection/insCell/inspList']);
          }else {
            this.router.navigate(['/main/internal/outbound/CZsQVJe0x6/dashboard']);
          }
          break;
        
      case 'Secretary Incharge':
          if (value === 'ecAgenda') {
            this.router.navigate(['/main/internal/excu/CZsQVJe0x6/ReviewMeetingComponent']);
          } else if (value === 'Inspection') {
            this.router.navigate(['/main/internal/inspection/insCell/inspList']);
          } else {
            this.router.navigate(['/main/internal/outbound/CZsQVJe0x6/dashboard']);
          }
          break;

      case 'Secretary':
        if (value === 'ecAgenda') {
          this.router.navigate(['/main/internal/excu/CZsQVJe0x6/ReviewMeetingComponent']);
        }  else if (value === 'Inspection') {
          this.router.navigate(['/main/internal/inspection/insCell/inspList']);
        } else {
          this.router.navigate(['/main/internal/outbound/CZsQVJe0x6/dashboard']);
        } 
        break;

        case 'Inspection Executive':
         if (value === 'Inspection') {
          this.router.navigate(['/main/internal/inspection/insCell/newinspList']);
        } 
        break;

      case 'President':
        if (value === 'ecAgenda') {
          this.router.navigate(['/main/internal/excu/president/presidentReviewMeetingComponent']);
        } else if(value === 'DakDairy') {
          this.router.navigate(['/main/internal/outbound/president/dashboard']);
        }  else if (value === 'Inspection') {
          this.router.navigate(['/main/internal/inspection/insCell/newinspList']);
        } 
        break;
         case 'Chairperson':
        if (value === 'ecAgenda') {
          this.router.navigate(['/main/internal/excu/president/presidentReviewMeetingComponent']);
        } else if(value === 'DakDairy') {
          this.router.navigate(['/main/internal/outbound/president/dashboard']);
        }  else if (value === 'Inspection') {
          this.router.navigate(['/main/internal/inspection/insCell/newinspList']);
        } 
        break;
      case 'Senior Secretariat Assistant':
        if (value === 'DMS') {
          // this.dms(this.DMSLink);
        } else if (value === 'Grievance') {
          this.router.navigate(['/main/internal/grievance/section/dashboard']);
        } else {
          this.router.navigate(['/main/internal/outbound/se/dashboard']);
        }
        break;
      case 'Junior Secretariat Assistant':
        this.router.navigate(['/main/internal/outbound/jsa/dash']);
        break;
      // Inspection Module 
      case 'InspectionCell':
            this.router.navigate(['/main/internal/inspection/insCell/inspList']);
        break;
      case 'TravelAgent':
        this.router.navigate(['/main/internal/inspection/tavelagent/dashboard']);
        break;
      // College Principal
      case 'College Principal':
        if (value === 'Grievance') {
          if(this.complaintCount === 0) {
            this.router.navigate(['/main/internal/grievance/complaint/new']);
          } else {
            this.router.navigate(['/main/internal/grievance/complaint/dashboard']);
          }
        } else if (value === 'StudentAdmission') {
          this.router.navigate(['/main/internal/college/dean/studentsList']);    // Student Admission Module
        } else if (value === 'proforma') {
          this.router.navigate(['/main/internal/college/proforma']);    // Student Admission Module
        } else if (value === 'PTR') {
          this.router.navigate(['/main/internal/ptr/dashboard/0']);    // Student Admission Module
        } else if(value === 'SA') {
          this.router.navigate(['/main/internal/college/collegeProfile/collegeDashboard']);    // College Profile Management
        } else if(value === 'SAR') {
          this.router.navigate(['/main/internal/college/viewSar/generalInformation']);    // College Profile Management View
        } else if (value === 'AntiRagging') {
          this.router.navigate(['/main/internal/antiRagging/antiRaggingList']);
        } 
        else if (value === 'antiRaggingOrientationProgram') {
          this.router.navigate(['/main/internal/orientationProgram/antiRaggingOrientationProgramList']);
        }else if (value === 'Fee Collection') {
          this.router.navigate(['/main/internal/college/feecollectiondetails/viewFeeList']);
        }
        else {
          this.router.navigate(['/main/internal/college/collegeRep/coursecompletionStudentList']);    // Course Completion Module
        } 
        break;
        case 'College Representative':
        if(value === 'SA') {
          this.router.navigate(['/main/internal/college/collegeProfile/collegeDashboard']);    // College Profile Management
        } else if(value === 'SAR') {
          this.router.navigate(['/main/internal/college/viewSar/generalInformation']);    // College Profile Management View
        } 
        break;
      case 'Student Admission Executive':
        if (value === 'DakDairy') {
          this.router.navigate(['/main/internal/outbound/se/dashboard']);
        } else {
        this.router.navigate(['/main/internal/college/admissionMonitorCellExecutive/collegelist']);// Student Admission Module
        }
        break;
      case 'Stu Executive Commitee':
        this.router.navigate(['/main/internal/college/executiveCommittee/dashboard']);    // Student Admission Module
        break;
      case 'AFExecutive':
        if (value === 'DakDairy') {
          this.router.navigate(['/main/internal/outbound/se/dashboard']);
        } else if (value === 'ecAgenda') {
          this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
        }
        break;
      case 'AFSectionOfficer':
        if (value === 'DakDairy') {
          this.router.navigate(['/main/internal/outbound/se/dashboard']);
        } else if (value === 'ecAgenda') {
          this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
        } if (value === 'Inspection') {
          this.router.navigate(['/main/internal/inspection/insCell/travelagentclaim']);
        }
        break;
      case 'AFAssistantSectionOfficer':
        if (value === 'DakDairy') {
          this.router.navigate(['/main/internal/outbound/se/dashboard']);
        } else if (value === 'ecAgenda') {
          this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
        }
        break;
      case 'LegalExecutive':
        if (value === 'DakDairy') {
          this.router.navigate(['/main/internal/outbound/se/dashboard']);
        } else if (value === 'Legal') {
          this.router.navigate(['/main/internal/legal/caseFileManagement']);
        } else if (value === 'ecAgenda') {
          this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
        }
        break;
      case 'AEExecutive':
        if (value === 'DakDairy') {
          this.router.navigate(['/main/internal/outbound/se/dashboard']);
        } else if (value === 'ecAgenda') {
          this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
        }
        break;
      case 'AEAssistantSecretary':
        if (value === 'DakDairy') {
          this.router.navigate(['/main/internal/outbound/se/dashboard']);
        } else if (value === 'ecAgenda') {
          this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
        }        
        break;
      case 'AESectionofficer':
        if (value === 'DakDairy') {
          this.router.navigate(['/main/internal/outbound/se/dashboard']);
        } else if (value === 'ecAgenda') {
          this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
        }
        break;
        case 'AEAssistantSectionOfficer':
          if (value === 'DakDairy') {
            this.router.navigate(['/main/internal/outbound/se/dashboard']);  // Diary Dak Module
          } else if (value === 'ecAgenda') {
            this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
          }
      case 'LegalAssistantSectionOfficer':
        if (value === 'DakDairy') {
          this.router.navigate(['/main/internal/outbound/se/dashboard']);
        } else if (value === 'Legal') {
          this.router.navigate(['/main/internal/legal/caseFileManagement']);
        } else if (value === 'ecAgenda') {
          this.router.navigate(['/main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
        }
     //added by gokul Grievance student
        case 'Student':
            if (value === 'Grievance') {
              if(this.complaintCount === 0) {
                this.router.navigate(['/main/internal/grievance/complaint/new']);
              } else {
                this.router.navigate(['/main/internal/grievance/complaint/dashboard']);
              }
            } else if(value === 'Eligibility') {
              if(this.eligibilityCount === 0) {
                this.router.navigate(['/main/internal/eligibility/raisenewrequest']);
              } else {
                this.router.navigate(['/main/internal/eligibility/dashboard/0']);
              }
            } else if(value === 'FQSR') {
              this.router.navigate(['/main/internal/fqsr/dashboard/0']);
            }
        break;

        case 'Inspector':
        if (value === 'Inspection') {
            this.router.navigate(['/main/internal/inspection/inspectionproforma/contactInspectionDasboard']);
        }        
        break;

      default:
        break;
    }
  }

  // DMS URL
  dms() {
    this.http.get(this.DMSLink).subscribe((res: any) => {
      window.open(res.dmsUrl, '_blank');
    }, error => {
      console.log(error);
    });
  }
    // DMS URL
    ERP() {
      this.http.get(this.ERPLink).subscribe((res: any) => {
        window.open(res.erpUrl, '_blank');
      }, error => {
        console.log(error);
      });
    }

    redirectToFQSRUserPage(){
      if(this.roleName === 'Student') {
        this.router.navigate(['/main/internal/fqsr/dashboard/0']);
      } else {
        this.router.navigate(['/main/internal/fqsr/secDashboard']);
      }
    }


NOC() {
  window.open(this.serverURL.nocPath, '_blank');
}

Profile(){
  window.open(this.serverURL.nocPath, '_blank');
}

    ITHelpDesk(){
      const obj = {
        moduleName: this.ced.encryptAesToString("ITHelpDesk", this.serverURL.secretKey).toString(),
        hostLocation: this.ced.encryptAesToString(window.location.hostname, this.serverURL.secretKey).toString(),
      }
      this.signin.getModuleURL(obj).subscribe((data: any) => {
        var ITHelpDeskReplacedString=data.moduleLinkURL.replace(/(?:\r\n|\r|\n)/g, '');
        var ITHelpDeskLink = this.ced.decryptAesformString(ITHelpDeskReplacedString, this.serverURL.secretKey);
        setTimeout (() => {
          window.open(ITHelpDeskLink, '_blank');
        }, 500); 
      }, error => {
        
      });
    }

    Accounts(){
      const obj = {
        moduleName: this.ced.encryptAesToString("Accounts", this.serverURL.secretKey).toString(),
        hostLocation: this.ced.encryptAesToString(window.location.hostname, this.serverURL.secretKey).toString(),
      }
      this.signin.getModuleURL(obj).subscribe((data: any) => {
        var AccountsReplacedString=data.moduleLinkURL.replace(/(?:\r\n|\r|\n)/g, '');
        var AccountsLink = this.ced.decryptAesformString(AccountsReplacedString, this.serverURL.secretKey);
        setTimeout (() => {
          window.open(AccountsLink, '_blank');
        }, 500); 
      }, error => {
        
      });
    }    

    MIS() {
      const obj = {
        moduleName: this.ced.encryptAesToString("MIS", this.serverURL.secretKey).toString(),
        hostLocation: this.ced.encryptAesToString(window.location.hostname, this.serverURL.secretKey).toString(),
      }
      this.signin.getModuleURL(obj).subscribe((data: any) => {
        var MISReplacedString=data.moduleLinkURL.replace(/(?:\r\n|\r|\n)/g, '');
        var MISLink = this.ced.decryptAesformString(MISReplacedString, this.serverURL.secretKey);
        setTimeout (() => {
          window.open(MISLink, '_blank');
        }, 500); 
      }, error => {
        
      });
    }
   
    MDM(){
      this.router.navigate(['/main/internal/inbound/sectionincharge/countryMaster']); 
    }

    NewCollege(){
    this.router.navigate(['/main/internal/NewCollege']);
    }

    UIDRClick(){      
      if(this.roleName==='ARPMSecInCharge' || this.roleName==='ARPMAsstSecty' || this.roleName==='UIDR'){
        this.router.navigate(['/main/internal/uidr/sectionDashboard']);
      } 
    }

    HRMS() {
      this.HRMSLink = `${this.serverURL.apiServerAddress}user-management/api/v1/user/HRMSUrl`;
      this.http.get(this.HRMSLink).subscribe((res: any) => {
        window.open(res.hrmsUrl, '_blank');
      }, error => {
        console.log(error);
      });
    
    }

    Advocate(){
      if(this.advocateDetails.profileCompleted==false){
      this.router.navigate(['/main/internal/legal/AdvocateProfileComponent/',this.advocateDetails.advocateId]);
      } else {
        this.router.navigate(['/main/internal/legal/AdvocateAssignedCasesComponent']);
      }
    }
   
    getComplaintListCount() {
      this.complSer.getAllComplaintListCount().subscribe((res: any) => {        
        this.complaintCount = res;
      }, error => {
        console.log(error);
      });
    }

    getEligibilityListCount() {
      this.ecService.getAllEligibilityListCount().subscribe((res: any) => {        
        this.eligibilityCount = res;
      }, error => {
        console.log(error);
      });
    }

    sendMobileOTPTemplate() {
      this.signin.sendMobileOTPTemplate().subscribe((result: any) => {
        console.log(result);
      });
    }
}
